var VtPluginSocket = {
  hSession: "",
  serialNumber: "",
  initPlugin: function () {
    var functionName = "getSession";
    var response = this.ajaxFunction(functionName, null, null);
    if (response) {
      var responseJson = JSON.parse(response);
      this.hSession = responseJson.sessionId;
      return true;
    }
    return false;
  },
  getSessionId: function () {
    var functionName = "getSession";
    var response = this.ajaxFunction(functionName, null, null);
    if (response) {
      var responseJson = JSON.parse(response);
      var sessionId = responseJson.sessionId;
      return sessionId;
    }
    return null;
  },
  getCert: function () {
    let certUserBase64 = "";
    if (!this.hSession) {
      return certUserBase64;
    }
    var functionName = "getCert";
    var paramNameArray = ["sessionId"];
    var paramValueArray = [this.hSession];
    var response = this.ajaxFunction(functionName, paramNameArray, paramValueArray);

    var responseAsJSON = JSON.parse(response);
    var error = responseAsJSON.error;
    var cert = responseAsJSON.cert;
    var {cn, dn, issuerCn, issuerDn, serialNumber, validFrom, validTo} = cert;
    let {certBase64} = cert;
    this.serialNumber = serialNumber;
    if (certBase64) {
      certBase64 = certBase64.replace("-----BEGIN CERTIFICATE-----", "");
      certBase64 = certBase64.replace("-----END CERTIFICATE-----", "");
      certBase64 = certBase64.trim();
      certUserBase64 = certBase64;
    }
    return certUserBase64;
  },
  getCertinUsb: function (comp) {
    comp.blockUI.start('');
    var sessionId = this.getSessionId();
    var returnData = {
      sessionId: sessionId,
      serialNumber: '',
      certUserBase64: '',
      certRawdata: '',
      issuedTo: '',
      distinguishedName: '',
      taxCode: '',
      issuedBy: '',
      activeDate: null,
      expireDate: null
    };
    var certUserBase64 = '';
    if (!sessionId) {
      return null;
    }
    const functionName = 'getCert';
    const paramNameArray = ['sessionId'];
    const paramValueArray = [sessionId];
    const response = this.ajaxFunction(functionName, paramNameArray, paramValueArray);
    const responseAsJSON = JSON.parse(response);
    const error = responseAsJSON.error;
    const cert2 = responseAsJSON.cert;
    if (!cert2) {
      return null;
    }
    const {cn, dn, issuerCn, issuerDn, serialNumber, validFrom, validTo} = cert2;

    // const {serialNumber} = cert2;
    let {certBase64} = cert2;
    returnData = {
      ...returnData,
      issuedTo: cn,
      distinguishedName: dn,
      taxCode: subStringTaxCode(dn),
      issuedBy: issuerCn,
      activeDate: validFrom,
      expireDate: validTo,
      serialNumber: serialNumber
    };

    if (certBase64) {
      certBase64 = certBase64.replace('-----BEGIN CERTIFICATE-----', '');
      certBase64 = certBase64.replace('-----END CERTIFICATE-----', '');
      certBase64 = certBase64.trim();
      certUserBase64 = certBase64;
      returnData.certUserBase64 = certUserBase64;
      returnData.certRawdata = certBase64;
    }
    return returnData;
  },
  signHash: function (base64Hash) {
    let signature = "";
    if (!this.hSession || !base64Hash || !this.serialNumber) {
      return signatureBase64;
    }

    var functionName = "signHash";
    var paramNameArray = ["sessionId", "serialNumber", "hashBase64", "hashAlg"];
    // var paramValueArray = [this.hSession, this.convertBase64ToHexa(base64Hash), 0]; //HashOpt: loai ma hash (0: SHA-1; 1:MD5; 2:SHA256)
    var paramValueArray = [sessionId, serialNumber, base64Hash, "SHA256"]; //HashOpt: loai ma hash (0: SHA-1; 1:MD5; 2:SHA256)
    var response = this.ajaxFunction(functionName, paramNameArray, paramValueArray);
    var responseAsJSON = JSON.parse(response);
    var {error, signatureBase64} = responseAsJSON;
    if (signatureBase64) {
      signature = signatureBase64;
    }
    return signature;
  },
  anonymousSignHash: function (base64Hash, sessionId, serialNumber) {
    let signature = "";
    if (!sessionId || !base64Hash || !serialNumber) {
      return signature;
    }

    var functionName = "signHash";
    var paramNameArray = ["sessionId", "serialNumber", "hashBase64", "hashAlg"];
    // var paramValueArray = [this.hSession, this.convertBase64ToHexa(base64Hash), 0]; //HashOpt: loai ma hash (0: SHA-1; 1:MD5; 2:SHA256)
    var paramValueArray = [sessionId, serialNumber, base64Hash, "SHA256"]; //HashOpt: loai ma hash (0: SHA-1; 1:MD5; 2:SHA256)
    this.ajaxFunctionAsync(functionName, paramNameArray, paramValueArray).then(
      (response) => {
        if (response) {
          var responseAsJSON = JSON.parse(response);
          var {error, signatureBase64} = responseAsJSON;
          if (signatureBase64) {
            signature = signatureBase64;
          }
        }
      }
    )
    return signature;
  },
  getLastErrorCode: function () {
    let errorCode = "";
    var functionName = "getLastErr";
    var response = this.ajaxFunction(functionName);
    if (!response) {
      errorCode = response;
    }
    return errorCode;
  },
  ajaxFunction: function (functionName, paramNameArray, paramValueArray) {
    //validate
    let response = "";
    if (!functionName) {
      return response;
    }
    let xmlhttp;
    if (window.XMLHttpRequest) {
      // code for IE7+, Firefox, Chrome, Opera, Safari
      xmlhttp = new XMLHttpRequest();
    } else {
      // code for IE6, IE5
      xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
        response = xmlhttp.responseText;
      }
    };
    var method = "POST";
    var url = "http://127.0.0.1:19650/" + functionName;
    var async = true; //Gui yeu cau chay dong bo
    xmlhttp.open(method, url, async);
    xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    if (!paramNameArray || !Array.isArray(paramNameArray) || paramNameArray.length === 0
      || !paramValueArray || !Array.isArray(paramValueArray) || paramValueArray.length === 0
      || paramNameArray.length !== paramValueArray.length) {
      try {
        xmlhttp.send();
      } catch (err) {
        return response;
      }
    } else {
      let data = "";
      for (let i = 0; i < paramNameArray.length; i++) {
        data += paramNameArray[i] + "=" + paramValueArray[i] + "&";
      }
      if (data.length > 0) {
        data = data.substring(0, data.length - 1); //Loai bo ky tu & cuoi cung
      }

      try {
        xmlhttp.send(data);
      } catch (err) {
        return response;
      }
    }
    return response;
  },
  ajaxFunctionAsync: function (functionName, paramNameArray, paramValueArray) {
    return new Promise(((resolve, reject) => {
      //validate
      let response = "";
      if (!functionName) {
        reject(response);
      }
      let xmlhttp;
      if (window.XMLHttpRequest) {
        // code for IE7+, Firefox, Chrome, Opera, Safari
        xmlhttp = new XMLHttpRequest();
      } else {
        // code for IE6, IE5
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          response = xmlhttp.responseText;
          resolve(response);
        }
      };
      var method = "POST";
      var url = "http://127.0.0.1:19650/" + functionName;
      var async = true; //Gui yeu cau chay dong bo
      xmlhttp.open(method, url, async);
      xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      if (!paramNameArray || !Array.isArray(paramNameArray) || paramNameArray.length === 0
        || !paramValueArray || !Array.isArray(paramValueArray) || paramValueArray.length === 0
        || paramNameArray.length !== paramValueArray.length) {
        try {
          xmlhttp.send();
        } catch (err) {
          reject(err);
        }
      } else {
        let data = "";
        for (let i = 0; i < paramNameArray.length; i++) {
          data += paramNameArray[i] + "=" + paramValueArray[i] + "&";
        }
        if (data.length > 0) {
          data = data.substring(0, data.length - 1); //Loai bo ky tu & cuoi cung
        }

        try {
          xmlhttp.send(data);
        } catch (err) {
          reject(err);
        }
      }
      // resolve(response);
    }))
  },
  dec2hex: function (d) {
    var hD = "0123456789ABCDEF";
    let h = hD.substr(d & 15, 1);
    while (d > 15) {
      d >>= 4;
      h = hD.substr(d & 15, 1) + h;
    }
    return h;
  },
  base64_decode: function (stringBase64) {
    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = [];
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    stringBase64 = stringBase64.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    if (stringBase64.length % 4) {
      return "";
    }

    let j = 0;
    while (i < stringBase64.length) {

      enc1 = keyStr.indexOf(stringBase64.charAt(i++));
      enc2 = keyStr.indexOf(stringBase64.charAt(i++));
      enc3 = keyStr.indexOf(stringBase64.charAt(i++));
      enc4 = keyStr.indexOf(stringBase64.charAt(i++));
      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;
      output[j++] = chr1;
      if (enc3 !== 64) {
        output[j++] = chr2;
      }
      if (enc4 !== 64) {
        output[j++] = chr3;
      }
    }
    return output;
  },
  convertBase64ToHexa: function (stringBase64) {
    var output = this.base64_decode(stringBase64);
    var separator = "";
    let hexText = "";
    for (let i = 0; i < output.length; i++) {
      hexText = hexText + separator + (output[i] < 16 ? "0" : "") + this.dec2hex(output[i]);
    }
    return hexText;
  },
  ERROR_CODE: {
    100100: "Lỗi chọn CTS",
    100101: "Lỗi Plugin",
    100102: "CTS không hợp lệ",
    100103: "Session không hợp lệ",
    100104: "CTS hết hạn",
    100200: "Dữ liệu lỗi",
    100201: "Không tìm thấy CTS",
    100202: "CTS không hợp lệ",
    100203: "Lỗi xảy ra trong quá trình ký",
    100204: "Tràn bộ nhớ",
    100205: "Session không hợp lệ",
    100300: "Chữ ký không đúng định dạng",
    100301: "Lỗi phân tích CTS",
    100302: "Chữ ký không hợp lệ",
    100303: "Session không hợp lệ",
  },
};
